<div class="page-container list-page-container" [testId]="'aiff-list-page-container'">
  <div class="page-topbar header-section" [testId]="'aiff-list-header-section'">
    <div class="page-header header-main" [testId]="'aiff-list-header-main'">
      <div class="page-heading title-section" [testId]="'aiff-list-title-section'">
        <h3 class="page-title" [testId]="'aiff-list-title'">{{ pageTitleKey | i18n }}</h3>
      </div>
      <div class="page-actions primary-actions" [testId]="'aiff-list-primary-actions'">
        <button nz-button (click)="search()" nzType="default" class="refresh-button" [testId]="'aiff-list-refresh-button'">
          <nz-icon nzType="reload" nzTheme="outline" [testId]="'aiff-list-refresh-icon'" />
          {{ 'common.refresh' | i18n }}
        </button>
        <button nz-button (click)="addAiff()" nzType="primary" class="add-button" [testId]="'aiff-list-add-button'">
          <i nz-icon nzType="plus" [testId]="'aiff-list-add-icon'"></i>
          {{ 'tenant.aiff.add' | i18n }}
        </button>
      </div>
    </div>
    <div class="topbar-search toolbar-row" [testId]="'aiff-list-toolbar-row'">
      <div class="topbar-search-row has-controls search-container" [testId]="'aiff-list-search-container'">
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'aiff-list-search-input-group'">
          <input
            [testId]="'aiff-list-search-input'"
            type="text"
            nz-input
            placeholder="{{ 'tenant.aiff.search-placeholder' | i18n }}"
            [(ngModel)]="searchKeyword"
            (keyup.enter)="search()"
          />
          <ng-template #suffixIconSearch [testId]="'aiff-list-search-icon-template'">
            <i
              nz-icon
              nzType="search"
              class="search-icon"
              nz-tooltip
              [nzTooltipTitle]="'tenant.aiff.search-tooltip' | i18n"
              (click)="search()"
              [testId]="'aiff-list-search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <div class="toolbar-controls" [testId]="'aiff-list-toolbar-controls'">
          <button
            [testId]="'aiff-list-reset-button'"
            nz-button
            nzType="default"
            (click)="resetSearch()"
            class="reset-button"
            nz-tooltip
            [nzTooltipTitle]="'tenant.aiff.reset-tooltip' | i18n"
          >
            <i nz-icon nzType="clear" [testId]="'aiff-list-reset-icon'"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="page-scroll" #mobileScrollContainer [testId]="'aiff-list-page-scroll'">
    <div class="result-meta" [testId]="'aiff-list-result-meta'">
      <div class="result-count" [testId]="'aiff-list-result-count'">
        {{ 'tenant.aiff.current-records' | i18n: { total: total } }}
      </div>
    </div>

    <div class="content-section" [testId]="'aiff-list-content-section'">
      <div class="table-section" [testId]="'aiff-list-table-section'">
        <nz-table
          [testId]="'aiff-list-table'"
          #basicTable
          class="table-container fixed-header-table"
          nzSize="middle"
          [nzScroll]="embeddedMode ? { x: '1040px' } : { x: '1040px', y: '100%' }"
          [nzData]="listOfData"
          [nzFrontPagination]="false"
          [nzLoading]="loading"
          [nzShowPagination]="false"
        >
          <thead [testId]="'aiff-list-table-head'">
            <tr [testId]="'aiff-list-table-header-row'">
              <th scope="col" nzWidth="360px" [testId]="'aiff-list-header-name'">{{ 'tenant.aiff.name' | i18n }}</th>
              <th scope="col" nzWidth="260px" [testId]="'aiff-list-header-endpoint'">{{ 'tenant.aiff.endpoint.url' | i18n }}</th>
              <th scope="col" nzWidth="230px" [testId]="'aiff-list-header-settings'">{{ 'tenant.aiff.settings.info' | i18n }}</th>
              <th scope="col" nzWidth="170px" [testId]="'aiff-list-header-update-time'">{{ 'tenant.aiff.update.time' | i18n }}</th>
              <th scope="col" nzWidth="110px" [testId]="'aiff-list-header-actions'">{{ 'common.actions' | i18n }}</th>
            </tr>
          </thead>
          <tbody [testId]="'aiff-list-table-body'">
            <tr *ngFor="let item of listOfData; let i = index" (click)="editAiff(item.id)" [testId]="'aiff-list-table-row-' + i">
              <td [testId]="'aiff-list-cell-name-' + i">
                <div class="aiff-identity">
                  <img
                    *ngIf="item.displayPictureUrl; else desktopPictureFallback"
                    class="aiff-thumbnail"
                    [src]="item.displayPictureUrl"
                    [alt]="item.name"
                    [testId]="'aiff-list-picture-' + i"
                  />
                  <ng-template #desktopPictureFallback>
                    <div class="aiff-thumbnail aiff-thumbnail-fallback" [testId]="'aiff-list-picture-fallback-' + i">
                      <nz-icon nzType="picture" nzTheme="outline" />
                    </div>
                  </ng-template>
                  <div class="aiff-copy">
                    <div class="aiff-name">{{ item.name }}</div>
                    <div class="aiff-description">{{ item.description || ('common.no-data' | i18n) }}</div>
                  </div>
                </div>
              </td>
              <td [testId]="'aiff-list-cell-endpoint-' + i">
                <a
                  *ngIf="item.endPointUrl; else noEndpoint"
                  class="endpoint-link"
                  [href]="item.endPointUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="$event.stopPropagation()"
                  [testId]="'aiff-list-endpoint-' + i"
                  [title]="item.endPointUrl"
                >
                  {{ item.endPointUrl }}
                </a>
                <ng-template #noEndpoint><span class="muted-value">-</span></ng-template>
              </td>
              <td [testId]="'aiff-list-cell-settings-' + i">
                <div class="settings-summary">
                  <span class="setting-count" [testId]="'aiff-list-setting-count-' + i">
                    {{ 'tenant.aiff.setting-count' | i18n: { count: (item.items || []).length } }}
                  </span>
                  <div class="setting-tags" *ngIf="getDisplayTypes(item).length">
                    <nz-tag
                      *ngFor="let type of getDisplayTypes(item).slice(0, 2); let typeIndex = index"
                      [nzColor]="getDisplayTypeColor(type)"
                      [testId]="'aiff-list-setting-type-' + i + '-' + typeIndex"
                    >
                      {{ getDisplayTypeText(type) }}
                    </nz-tag>
                    <span class="setting-more" *ngIf="getDisplayTypes(item).length > 2">+{{ getDisplayTypes(item).length - 2 }}</span>
                  </div>
                </div>
              </td>
              <td [testId]="'aiff-list-cell-update-time-' + i">{{ item.updateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
              <td (click)="$event.stopPropagation()" [testId]="'aiff-list-cell-actions-' + i">
                <button
                  [testId]="'aiff-list-edit-button-' + i"
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  nzShape="circle"
                  (click)="editAiff(item.id)"
                  [nzTooltipTitle]="'common.edit' | i18n"
                  nz-tooltip
                >
                  <nz-icon nzType="edit" nzTheme="outline" [testId]="'aiff-list-edit-icon-' + i" />
                </button>
                <nz-divider nzType="vertical" [testId]="'aiff-list-divider-' + i" />
                <button
                  [testId]="'aiff-list-delete-button-' + i"
                  nz-button
                  nzType="primary"
                  nzDanger
                  nzSize="small"
                  nzShape="circle"
                  (click)="deleteAiff(item.id)"
                  [nzTooltipTitle]="'common.delete' | i18n"
                  nz-tooltip
                >
                  <nz-icon nzType="delete" nzTheme="outline" [testId]="'aiff-list-delete-icon-' + i" />
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>

      <div class="mobile-card-section" [testId]="'aiff-list-mobile-section'">
        <nz-spin [nzSpinning]="loading">
          <div class="mobile-card-list">
            <div class="aiff-card" *ngFor="let item of listOfData; let i = index" [testId]="'aiff-list-mobile-card-' + i">
              <div class="aiff-card-header">
                <img
                  *ngIf="item.displayPictureUrl; else mobilePictureFallback"
                  class="aiff-thumbnail"
                  [src]="item.displayPictureUrl"
                  [alt]="item.name"
                  [testId]="'aiff-list-mobile-picture-' + i"
                />
                <ng-template #mobilePictureFallback>
                  <div class="aiff-thumbnail aiff-thumbnail-fallback">
                    <nz-icon nzType="picture" nzTheme="outline" />
                  </div>
                </ng-template>
                <div class="aiff-card-title-wrap">
                  <div class="aiff-card-title" [testId]="'aiff-list-mobile-name-' + i">{{ item.name }}</div>
                  <div class="aiff-card-desc" [testId]="'aiff-list-mobile-description-' + i">
                    {{ item.description || ('common.no-data' | i18n) }}
                  </div>
                </div>
              </div>

              <div class="aiff-card-detail-rows">
                <div class="detail-row">
                  <span class="detail-label">{{ 'tenant.aiff.endpoint.url' | i18n }}：</span>
                  <a
                    *ngIf="item.endPointUrl; else mobileNoEndpoint"
                    class="detail-value endpoint-link"
                    [href]="item.endPointUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ item.endPointUrl }}
                  </a>
                  <ng-template #mobileNoEndpoint><span class="detail-value">-</span></ng-template>
                </div>
                <div class="detail-row detail-row-settings">
                  <span class="detail-label">{{ 'tenant.aiff.settings.info' | i18n }}：</span>
                  <span class="detail-value">{{ 'tenant.aiff.setting-count' | i18n: { count: (item.items || []).length } }}</span>
                  <div class="setting-tags" *ngIf="getDisplayTypes(item).length">
                    <nz-tag *ngFor="let type of getDisplayTypes(item).slice(0, 2)" [nzColor]="getDisplayTypeColor(type)">
                      {{ getDisplayTypeText(type) }}
                    </nz-tag>
                  </div>
                </div>
                <div class="detail-row">
                  <span class="detail-label">{{ 'tenant.aiff.update.time' | i18n }}：</span>
                  <span class="detail-value">{{ item.updateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
                </div>
              </div>

              <div class="aiff-card-actions">
                <button
                  nz-button
                  nzType="default"
                  type="button"
                  class="card-action-btn card-action-edit"
                  (click)="editAiff(item.id)"
                  [testId]="'aiff-mobile-edit-button-' + item.id"
                >
                  <i nz-icon nzType="edit"></i>
                  {{ 'common.edit' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  nzDanger
                  type="button"
                  class="card-action-btn card-action-danger"
                  (click)="deleteAiff(item.id)"
                  [testId]="'aiff-mobile-delete-button-' + item.id"
                >
                  <i nz-icon nzType="delete"></i>
                  {{ 'common.delete' | i18n }}
                </button>
              </div>
            </div>
          </div>

          <div
            class="mobile-load-more-anchor"
            #mobileLoadMoreAnchor
            *ngIf="isMobileView && hasMoreMobile"
            [testId]="'aiff-list-mobile-load-anchor'"
          ></div>
          <div class="mobile-load-more" *ngIf="isLoadingMore" [testId]="'aiff-list-mobile-loading-more'">
            {{ 'common.loading' | i18n }}
          </div>
        </nz-spin>
      </div>

      <div class="content-footer" *ngIf="total > 0 && !isMobileView" [testId]="'aiff-list-content-footer'">
        <div class="pagination-section pagination-container" [testId]="'aiff-list-pagination-section'">
          <div class="pagination-info" [testId]="'aiff-list-pagination-info'">
            {{ 'tenant.aiff.page-records' | i18n: { page: pageIndex, total: total } }}
          </div>
          <div class="pagination-controls" [testId]="'aiff-list-pagination-controls'">
            <button nz-button nzSize="small" [disabled]="pageIndex <= 1" (click)="previousPage()" [testId]="'aiff-list-previous-page'">
              <nz-icon nzType="left" nzTheme="outline" />
              {{ 'tenant.aiff.previous-page' | i18n }}
            </button>
            <button nz-button nzSize="small" [disabled]="!hasNextPage" (click)="nextPage()" [testId]="'aiff-list-next-page'">
              {{ 'tenant.aiff.next-page' | i18n }}
              <nz-icon nzType="right" nzTheme="outline" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
